exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tether-element, .tether-element:after, .tether-element:before, .tether-element *, .tether-element *:after, .tether-element *:before {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box; }\n\n.tether-element {\n  position: absolute;\n  display: none; }\n\n.tether-element.tether-open {\n    display: block; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /builds/maxmatthiessen/applications/advice4lifeweb/node_modules/css-loader?{"sourceMap":false,"import":false}!/builds/maxmatthiessen/applications/advice4lifeweb/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!/builds/maxmatthiessen/applications/advice4lifeweb/node_modules/tether/dist/css/tether.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"import":false}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../tether/dist/css/tether.css
// module chunks = styles